import '../assets/styles/WhyChooseUs.css';
import bgImage from '../assets/images/bg_side_4-1.jpg';

function WhyChooseUs() {
  return (
    <section className="py-5">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <h2 className="why-choose-title fw-bold mb-4">Why Choose Us</h2>
            <p className="main-description">
              With over 30 years of expertise in logistics, RFF Cargo delivers innovative, reliable solutions for global freight and supply chain management, ensuring seamless delivery and exceptional value.
            </p>
            <div className="mt-4">
              <div className="d-flex align-items-start mb-3">
                <i className="bi bi-star-fill me-3 icon"></i>
                <div>
                  <h3 className="h5 subsection-title">Customer Satisfaction Tools</h3>
                  <p className="subsection-text">
                    Our advanced tracking systems and dedicated support teams prioritize customer satisfaction, providing real-time updates and personalized service to meet your needs.
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-start mb-3">
                <i className="bi bi-bar-chart-fill me-3 icon"></i>
                <div>
                  <h3 className="h5 subsection-title">Management and Reporting</h3>
                  <p className="subsection-text">
                    RFF Cargo offers comprehensive management tools and detailed reporting, empowering clients with data-driven insights to optimize their supply chain operations.
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-start">
                <i className="bi bi-wallet2 me-3 icon"></i>
                <div>
                  <h3 className="h5 subsection-title">Freight Payment Solutions</h3>
                  <p className="subsection-text">
                    We provide flexible and secure freight payment solutions, streamlining billing processes and ensuring cost-effective logistics for businesses of all sizes.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 right-column" style={{ backgroundImage: `url(${bgImage})` }}>
            <div className="image-overlay"></div>
            <div className="signature-overlay">
              <h3 className="signature-title">RFF Cargo Commitment</h3>
              <p className="signature-text">
                We are committed to being the leading logistics solutions provider for our customers. We continually improve and implement quality management to achieve this.
              </p>
              <p className="signature-name">Muhydin Jama</p>
              <p className="signature-position">Managing Director, RFF Cargo</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;